// Entrada de la app: decide qué cargar antes de traer nada pesado.
//
//   - Sitio público (`<slug>.<VITE_SITES_BASE_DOMAIN>`, `?site=<slug>` en
//     desarrollo, o `/s/<slug>` dentro de la app): solo el sitio
//     (components/sites/host/site-host-app.tsx), con su router pequeño. Sin
//     el router del ERP, su login, proveedores, DevTools, analítica ni el
//     service worker.
//   - Lo demás: el ERP (app/erp-main.tsx).
//
// Cada uno va en su propio chunk: este archivo no debe importar nada del ERP
// (lo que importe aquí lo descarga también el visitante de un sitio).
// Medición antes y después: docs/sitios-publicos.md («Carga liviana»).

import { currentSiteHost } from "@/lib/sites/host";
import { publicSiteSlugFromPath } from "@/lib/sites/paths";

const siteHost = currentSiteHost();
const sitePathSlug = siteHost ? null : publicSiteSlugFromPath(window.location.pathname);

if (siteHost || sitePathSlug) {
  void import("@/components/sites/host/site-host-app").then(({ mountSite }) =>
    mountSite(siteHost ? { slug: siteHost.slug, onSiteHost: true } : { slug: sitePathSlug!, onSiteHost: false }),
  );
} else {
  void import("./erp-main");
}
